import classSelectTrait from "./traits/classSelectTrait";
import contentTrait from "./traits/contentTrait";
import focalPointTrait from "./traits/focalPointTrait";
import mediaLibrarySelectTrait from "./traits/mediaLibrarySelectTrait";
import recursiveMenuTrait from "./traits/recursiveMenuTrait";
import sizeWithUnitTrait from "./traits/sizeWithUnitTrait";
import sliderWithInputTrait from "./traits/sliderWithInputTrait";
import responsiveSizesTrait from "./traits/responsiveSizesTrait";

export default (editor, config = {}) => {
    classSelectTrait(editor);
    contentTrait(editor);
    focalPointTrait(editor);
    mediaLibrarySelectTrait(editor);
    recursiveMenuTrait(editor);
    sizeWithUnitTrait(editor);
    sliderWithInputTrait(editor);
    responsiveSizesTrait(editor);
};
